import React from 'react';
import { NavLink } from 'react-router-dom';
import NavIcon from './NavIcon.jsx';
import { WithTooltip } from '@/components/ui/tooltip';

/**
 * A single navigation link (top-level leaf or group child).
 *
 * @param {object} props
 * @param {object} props.item — `{ route, label, icon }`
 * @param {string} props.currentRoute — active route key
 * @param {'top'|'sub'} [props.variant] — 'top' for crm-nav-item, 'sub' for crm-nav-subitem
 * @param {boolean} [props.collapsed] — when true, show flyout label tooltip (icon rail)
 * @param {Function} [props.onNavigate] — fired after a link is clicked
 */
export default function NavItem({ item, currentRoute, variant = 'top', collapsed = false, onNavigate }) {
    const isSub = variant === 'sub';
    const active = item.route === currentRoute;
    const cls = isSub ? 'crm-nav-subitem' : 'crm-nav-item';
    const showFlyoutTip = collapsed && !isSub;

    const link = (
        <NavLink
            className={`${cls}${active ? ' active' : ''}`}
            to={`/${item.route}`}
            data-nav-route={item.route}
            data-nav-tooltip={isSub ? undefined : item.label}
            aria-label={item.label}
            aria-current={active ? 'page' : undefined}
            onClick={() => onNavigate?.(item.route)}
        >
            <NavIcon name={item.icon} />
            <span className="crm-nav-label">{item.label}</span>
        </NavLink>
    );

    return (
        <WithTooltip
            content={item.label}
            side="right"
            sideOffset={10}
            disabled={!showFlyoutTip}
            delayDuration={80}
            contentClassName="crm-sidebar-radix-tooltip"
        >
            {link}
        </WithTooltip>
    );
}
